import { Fragment } from "react";
import { Reveal } from "../Reveal";

const chunk = (words, breaks) => {
  if (!breaks) return [words];
  let i = 0;
  return breaks.map((n) => words.slice(i, (i += n)));
};

export const SplitHeadline = ({ as = "h2", text, breaks, indents = [], emIdx = [], className = "", testid, delay = 0 }) => {
  const rows = chunk(text.split(" "), breaks);
  let idx = 0;
  return (
    <Reveal as={as} variant="words" className={`hl ${className}`} data-testid={testid}>
      {rows.map((row, r) => {
        const words = row.map((w, k) => {
          const i = idx++;
          return (
            <Fragment key={k}>
              {k > 0 && " "}
              <span className={`w ${emIdx.includes(i) ? "w-em" : ""}`}>
                <span className="w-in" style={{ transitionDelay: `${delay + i * 60}ms` }}>{w}</span>
              </span>
            </Fragment>
          );
        });
        return (
          <Fragment key={r}>
            {r > 0 && " "}
            {breaks ? <span className={`hl-line ind-${indents[r] || 0}`}>{words}</span> : words}
          </Fragment>
        );
      })}
    </Reveal>
  );
};
